import { useId } from "react";
import { cn } from "@/lib/utils";

export type Segment<T extends string> = { value: T; label: string };

/** Choose one of a few options (filters, views). A labelled radio group underneath. */
export function SegmentedControl<T extends string>({
  label,
  options,
  value,
  onChange,
  className,
}: {
  label: string;
  options: Segment<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}) {
  const name = useId();
  return (
    <fieldset className={cn("min-w-0", className)}>
      <legend className="sr-only">{label}</legend>
      <div className="inline-flex max-w-full flex-wrap gap-1 rounded-pill border border-border bg-surface p-1">
        {options.map((o) => (
          <label
            key={o.value}
            className={cn(
              "inline-flex min-h-9 cursor-pointer items-center rounded-pill px-4 text-sm font-medium transition-colors duration-fast has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-focus",
              value === o.value ? "bg-secondary text-secondary-fg" : "text-fg-muted hover:bg-secondary-subtle hover:text-heading",
            )}
          >
            <input
              type="radio"
              name={name}
              value={o.value}
              checked={value === o.value}
              onChange={() => onChange(o.value)}
              className="sr-only"
            />
            {o.label}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
